import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchDetailPostRequest } from "../store/actions";

export const useDetailPost = (dataParam?:any) => {
  const dispatch = useDispatch();
    const {
      loading,
      data,
    } = useSelector((state: any) => state.Community.detail || null);
    const { userInfo } = useSelector((state: any) => state.Auth);
    useEffect(() => {
      
      if (dataParam) {
        dispatch(fetchDetailPostRequest({ id: dataParam }));
      }
    }, [dataParam, dispatch, userInfo?.id]);
    return { 
      loading, 
      dataDetail: data,  
    }
};